import React from 'react';
import { Dispatch } from 'redux';
import Button from '@roo/roo/Button';
import { connect } from 'react-redux';
import Modal from '@roo/roo/Modal';
import * as LX from '@utils/lxWrapper';
import pageJump from '@projects/Shell/utils/pageJump';
import { RootState } from '../../../../../store';
import {
    IBusinessStatus,
    BusinessStatus,
    IBusinessStatusHandlerItem,
} from '../../../../../api/define';
import styles from './StatusOperation.module.scss';
import { getBookingInfo } from './api/getBookingInfo';

type StatusOperationProps = {
    businessStatusInfo: IBusinessStatus;
    statusItems: IBusinessStatusHandlerItem[];
    changeBusinessStatus: (status: number) => void;
};

const { useCallback } = React;

const StatusOperation: React.FC<StatusOperationProps> = ({
    businessStatusInfo,
    statusItems,
    changeBusinessStatus,
}) => {
    /** 切换营业状态 */
    const changeStatus = useCallback(
        (status: BusinessStatus) => {
            const confirmChangeBusinessStatus = () => {
                Modal.confirm({
                    title: '切换营业状态',
                    children:
                        businessStatusInfo.operationStatus === 1
                            ? '确认切换营业状态？您的歇业保护正在生效中，如恢复营业将自动撤销进行中的歇业保护'
                            : '确认切换营业状态？',
                    confirmText: '确认',
                    cancelText: '取消',
                    onConfirm: () => {
                        LX.reportMC('b_waimai_e_o0p6hv0l_mc', 'c_waimai_e_fa4ps4ng');
                        changeBusinessStatus(status);
                    },
                });
            };

            const confirmBookingInfo = (
                title?: string,
                detail?: string,
                confirmText?: string,
                cancelText?: string,
            ) => {
                Modal.confirm({
                    title: title ?? '商家置休确认',
                    children:
                        detail ??
                        '建议商家先行确认是否存在未完成的预订单。若预订单无法按时履约，请尽快与用户协商，以免置休后影响用户就餐',
                    cancelText: cancelText ?? '确认仍要置休',
                    confirmText: confirmText ?? '去查看预订单',
                    closable: false,
                    backdropClosable: false,
                    onCancel: () => confirmChangeBusinessStatus(),
                    onConfirm: () => pageJump.go('/new_fe/orderbusiness#/order/reserve'),
                });
            };

            // 停止营业
            if (status === BusinessStatus.REST) {
                LX.reportMC('b_waimai_e_n8htty3u_mc', 'c_waimai_e_fa4ps4ng', {
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    is_delivery_temp_biz_hour_effective: businessStatusInfo.hasSpecialShippingTime,
                });

                // 商家点击停止营业按钮，检查预订单
                getBookingInfo()
                    .then(data => {
                        const { isHasBookingInfo, tittle, detail, firstButton, secondButton } =
                            data || {};

                        if (!isHasBookingInfo) {
                            confirmChangeBusinessStatus();
                            return;
                        }

                        confirmBookingInfo(tittle, detail, firstButton, secondButton);
                    })
                    .catch(() => {
                        confirmBookingInfo();
                    });
            }

            // 恢复营业
            if (status === BusinessStatus.OPEN) {
                LX.reportMC('b_waimai_e_g65xixx1_mc', 'c_waimai_e_fa4ps4ng', {
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    is_delivery_temp_biz_hour_effective: businessStatusInfo.hasSpecialShippingTime,
                });

                confirmChangeBusinessStatus();
            }
        },
        [businessStatusInfo, changeBusinessStatus],
    );

    const buttonHandle = useCallback(
        btn => {
            if (btn.jumpUrl) {
                pageJump.go(btn.jumpUrl);
            } else if (btn.status) {
                changeStatus(btn.status);
            }
        },
        [businessStatusInfo, changeStatus],
    );

    return (
        <>
            {statusItems.map(item => {
                const { text, btn } = item;
                return (
                    <div className={styles.menuItem} key={item.text}>
                        <div className={styles.txt}>{text}</div>
                        <Button type="weaken" size="mini" onClick={() => buttonHandle(btn)}>
                            {item.btn.text}
                        </Button>
                    </div>
                );
            })}
        </>
    );
};

const mapStateToProps = (state: RootState) => {
    return {
        businessStatusInfo: state.shellHeader.poiBusinessStatus,
    };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
    changeBusinessStatus: (status: number) => {
        dispatch({ type: 'shellHeader/changeBusinessStatus', payload: status });
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(StatusOperation);
